<template>
  <nav :class="[ headerBg ? 'bg-lightgray' : '' ]" class="fixed top-0 w-full z-10 py-6 flex justify-between items-center px-4 sm:px-6">
    <a href="/"><img class="z-20 w-[160px]" src="./assets/common/logo.png" /></a>
    <div class="flex items-center">
      <a href="https://congrant.com/project/yuzuriha/7907" target="_blank" class="px-3 sm:px-4 py-2 bg-green-500 rounded-[3px] justify-center items-center inline-flex mr-2 sm:mr-4 text-xs donation_button">
        <span class="text-white font-bold leading-3 tracking-widest">寄付をする</span>
      </a>
      <Menu />
    </div>
  </nav>
  <div class="overflow-x-hidden w-full">
    <router-view></router-view>
  </div>
  <Footer/>
</template>

<script>
import gsap from "gsap";
import Menu from "./components/Menu";
import Footer from "./components/Footer";

export default {
  data() {
    return {
     bg: "#e6e6e6"
    }
  },
  components:{
    Menu,
    Footer
  },
  computed: {
    headerBg() {
      return location.pathname !== '/'
    }

  },
  mounted() {
    this.fadeDownNav()
  },
  methods: {
    fadeDownNav() {
      gsap.to('nav', {
        y: 0,
        duration: 1,
        ease: "power2.out",
        opacity: 1,
        delay: 1.2,
      });
    },
  }
}
</script>

<style lang="scss">

.donation_button {
  background: linear-gradient(95.98deg, rgb(68, 154, 95) 14.71%, rgb(68, 154, 95) 91.59%);
  transition: opacity 0.3s;
}

.donation_button:hover {
  opacity: 0.9;
}

.c-headingLine {
  @apply relative;

  .body {
    @apply bg-white relative pr-2 md:pr-4 font-medium;
  }
}

.c-headingLine:before {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: #000;
  bottom: 0.55em;
  position: absolute;
}

.c-btn {
  border: 1px solid #000;
  padding: 10px 20px;
  display: inline-block;
  color: #000;
  letter-spacing: 0.1em;
  position: relative;
  z-index: 2;
  background: #FFF;
  box-shadow: 3px 3px #d6d6d6;
  transition: all .2s;
  @apply text-xs;

  &--02 {
    @apply py-4 px-12;

    span {
      @apply mt-1 block text-[11px] md:text-base leading-none;
    }
  }

  &:hover {
    background: #000;
    color: #fff;
  }
}

.c-pageHerder {
  @apply bg-lightgray pt-[118px] md:pt-[147px] pb-[63px] md:pb-[137px];

  h1 {
    @apply text-3_5xl text-center flex flex-col items-center leading-[1.53] tracking-[0.22em] md:tracking-[0.2em];
    span {
      @apply text-xxs mb-[15px] md:mb-[6px] tracking-[0.4em];
    }

    &:after {
      content: '';
      display: block;
      height: 1px;
      width: 24px;
      background: #000;
      @apply mt-[25px] md:mt-[29px]
    }
  }
}

.c-table {
  div {
    display: flex;
    border-bottom: 1px solid #d6d6d6;
    padding: 16px 0;
  }
}

.c-title {
  &--01 {
    @apply text-[2.1875rem] tracking-[0.4em] font-medium;

    .en {
      @apply text-base tracking-[0.15em] block mt-6 leading-none font-light;

      &:after {
        display: block;
        content: '';
        width: 1.5em;
        height: 1px;
        background: black;
        @apply mt-8;
      }
    }

    &--noLine {
      span:after {
        content: none;
      }
    }
  }
  &--02 {
    @apply text-[23px] md:text-3xl text-center tracking-[0.2em] leading-none;
  }
  &--label {
    @apply text-[8px] md:text-xxs tracking-[5px] inline-block bg-white leading-none;
    padding: 0.6em 1em;
  }

  &--hasLine {
    @apply text-35 flex flex-col font-light;
    letter-spacing: 0.2em;
    line-height: 1;

    span {
      @apply text-base text-darkgray mt-[1.4rem];
      letter-spacing: 0.08em;
      line-height: 1;
    }

    &:after {
      content: '';
      display: block;
      height: 1px;
      width: 24px;
      background: #000;
      @apply mt-[25px] md:mt-[2.5rem] mx-auto;
    }
  }
}


.c-line {
  position: relative;
  &:before {
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
    content: '';
    display: block;
    background: #000;
    width: 1px;
    @apply h-[45px] md:h-[100px];
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// table

.table-list {
  margin-top: 0;
  @apply grid grid-cols-1 md:grid-cols-2;

  dt {
    background: #333333;
    color: #fff;
    border: 1px solid #FFFFFF;
    @apply flex items-center py-[0.5em] px-[8px] md:py-[10px] md:px-[20px] leading-normal;
  }

  dd {
    background: #e8e8e8;
    border: 1px solid #FFFFFF;
    @apply flex items-center py-[0.5em] px-[8px] md:py-[10px] md:px-[20px];

    a {
      text-decoration: none;
      @apply break-all hover:underline leading-normal block w-full;
    }
  }
}

.c-borderArea {
  @apply border relative mt-8 p-[17px] md:p-[40px];
  border-color: #333333;

  &--low {
    @apply py-5 md:py-[30px] px-5 md:px-[40px]
  }

  &__title {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    @apply text-center text-base tracking-widest;

    span {
      display: inline-block;
      background: #fff;
      transform: translateY(-50%);
      @apply px-2 font-medium;
    }
  }
  &__subtitle {
    @apply text-base
  }

  .mt-0 {
    margin-top: 0;
  }
}


.p-donation {

  p, ul, dl{
    @apply text-base mt-6 leading-[2.1];
  }

  p {
    @apply mt-6 text-justify;
  }

  p.text-center {
    text-align: center;
  }
  p.text-right {
    text-align: right;
  }

  p a, li a {
    color: #666666;
  }

  h2 {
    @apply text-3_5xl tracking-widest;
    .sub {
      @apply block text-[10px] scale-[0.8] origin-left md:scale-100 md:text-xxs;
      letter-spacing: 0.5em;
    }
  }

  h2 + p{
    @apply mt-5;
  }

  h3 {
    @apply mt-6 md:mt-10;
  }

  h3, h5 {
    @apply font-medium;
  }

  a {
    @apply underline hover:no-underline;
  }

  a.c-btn {
    @apply no-underline;
  }
  .c-headingLine:before {
    bottom: 0.6em;
  }
}

.js-fadeLeftRight,
.js-fadeRightLeft,
.js-fadeLeftRightGroup,
.js-fadeRightLeftGroup{
  position: relative;

  span {
    display: block;
    position: absolute;
    background: #fff;
    width: calc(100% + 2px) ;
    height: 100%;
    top: 0;
    left: -1px;
    transform-origin: right;
  }
}

.js-fadeRightLeft,
.js-fadeRightLeftGroup {
  span {
    transform-origin: left;
  }
}
//.js-fadeInUpGroup,
//.js-fadeInUp {
//  opacity: 0;
//  transform: translateY(30px);
//}

.in-view {
  opacity: 1;
  transform: translateY(0);

  img {
    opacity: 1;
    transform: scale(1);
  }
}

.inViewImage {
  @apply block overflow-hidden;
  transform: translateY(8rem);
  opacity: 0;
  transition: all 2s cubic-bezier(0,.7,.3,1);
  background: #f8f6ef;

  img {
    opacity: 0;
    transform: scale(1.1);
    transition: all 2s cubic-bezier(0,.7,.3,1) 0.2s;
  }

  &.in-view {
    opacity: 1;
    transform: translateY(0);

    img {
      opacity: 1;
      transform: scale(1);
    }

  }
}


</style>
